// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDqEL-u32oV3--GChGDy51eOVXEXK5HLgE",
  authDomain: "movieshub-5b714.firebaseapp.com",
  projectId: "movieshub-5b714",
  storageBucket: "movieshub-5b714.appspot.com",
  messagingSenderId: "988718309626",
  appId: "1:988718309626:web:bb7e1d30054143ab7de943"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;